export const leaveSetupApi = {
    heading:[
        
        {
            head:"ID"
        },
        {
            head:"Type"
        },
        {
            head:"Description"
        },
        {
            head:"Designation"
        },
        {
            head:"No of month"
        },
        {
            head:"leavebalance"
        },
        {
            head:"Cumulative"
        },
        {
            head:"Active From"
        },
        {
            head:"Active To"
        },
        {
            head:"Action"
        }
    ],
    data:[
       {
        id:452,
        type:"present",
        description:"leaving",
        designaiton:"Admin",
        noofmonth:"2",
        leavebalance:"5",
        cumulative:"true",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
       {
        id:452,
        type:"present",
        description:"leaving",
        designaiton:"Admin",
        noofmonth:"2",
        leavebalance:"5",
        cumulative:"true",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
       {
        id:452,
        type:"present",
        description:"leaving",
        designaiton:"Admin",
        noofmonth:"2",
        leavebalance:"5",
        cumulative:"true",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
       {
        id:452,
        type:"present",
        description:"leaving",
        designaiton:"Admin",
        noofmonth:"2",
        leavebalance:"5",
        cumulative:"true",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
       {
        id:452,
        type:"present",
        description:"leaving",
        designaiton:"Admin",
        noofmonth:"2",
        leavebalance:"5",
        cumulative:"true",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
       {
        id:452,
        type:"present",
        description:"leaving",
        designaiton:"Admin",
        noofmonth:"2",
        leavebalance:"5",
        cumulative:"true",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
       {
        id:452,
        type:"present",
        description:"leaving",
        designaiton:"Admin",
        noofmonth:"2",
        leavebalance:"5",
        cumulative:"true",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
       {
        id:452,
        type:"present",
        description:"leaving",
        designaiton:"Admin",
        noofmonth:"2",
        leavebalance:"5",
        cumulative:"true",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
       {
        id:452,
        type:"present",
        description:"leaving",
        designaiton:"Admin",
        noofmonth:"2",
        leavebalance:"5",
        cumulative:"true",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
       {
        id:452,
        type:"present",
        description:"leaving",
        designaiton:"Admin",
        noofmonth:"2",
        leavebalance:"5",
        cumulative:"true",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
       {
        id:452,
        type:"present",
        description:"leaving",
        designaiton:"Admin",
        noofmonth:"2",
        leavebalance:"5",
        cumulative:"true",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
      
     
   
       
    ]
}